var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"pendingan"},[_c('v-img',{staticClass:"pendingan",attrs:{"max-width":"650","src":"http://icon.irmastore.id/menunggu-approval.png"}}),_c('h2',[_vm._v("Sedang dalam tahap pengembangan")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }